import './enterprise.component.scss';

import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';

import { useEffect, useState, useCallback } from 'react';

import allImages from '../../../../assets/images/allImages';
import { Link, useNavigate } from 'react-router-dom';
import { AddEnterprise } from '../enterpriseList/AddEnterprise';
import { SendInvitation } from '../enterpriseList/SendInvitation';
import { Dropdown } from 'primereact/dropdown';
import { useApolloClient, useQuery } from '@apollo/client';
import { GetEnterpriseClients, GetOverallEnterpriseClientStats } from '../../../../Queries/QueriesUpdated';
import { setLoaderFalse, setLoaderTrue } from '../../../../Redux/loaderSlice';
import { useDispatch } from 'react-redux';
import { globalError } from '../../../../utils/global-error-handler';
import { isLogout } from '../../../../Redux/authSlice';

// import { client } from '../../../../apollo_server_connection';

export const EnterpriseList = () => {
  const navigate = useNavigate();
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [showSendInvitePopup, setShowSendInvitePopup] = useState(false);
  const [selectedEnterpriseName, setSelectedEnterpriseName] = useState();
  const [selectedEnterpriseLogo, SetselectedEnterpriseLogo] = useState();
  const [selectedEnterpriseID, setSelectedEnterpriseID] = useState();
  const [selectedRow, setSelectedRow] = useState();

  const [filters, setFilter] = useState({
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  const ClientSearchInput = {
    filter: {
      conditions: [
        {
          operator: "DOES_NOT_CONTAIN",
          property: "NAME",
          value: "$"
        }
      ]
    },
    "limit": 400,
    "offset": 0,
    "sort": "DESC"
  };

  const { loading, refetch, data } = useQuery(GetEnterpriseClients, {
    variables: { input: ClientSearchInput },
  });
  const {data: getOverallEnterpriseClientStats } = useQuery(GetOverallEnterpriseClientStats);

  useEffect(() => {
    // Trigger refetch on component mount or when specific dependencies change
    refetch();
  }, [refetch]);

  const websiteBody = (rowData) => {
    if(rowData?.url) {
      const modifiedURL = rowData?.url?.startsWith('https://')
        ? rowData?.url
        : `https://${rowData.url}`;
      return (
        <>
          <Link to={modifiedURL} target="_blank">
            {rowData?.url ?? ''}
          </Link>
        </>
      );
    }
  };

  const enterpriseNameBody = (rowData) => {
    return (
      <>
        <img
          src={rowData?.logo ? rowData?.logo.presignedURL : allImages.bondLogo}
          className="me-4"
          style={{ height: '2rem', width: '3.5rem'}}
          alt="enterpriseLogo"
        />
        {rowData?.name ?? ''}
      </>
    );
  };

  const enterpriseAddressBody = (rowData) => {
    if(rowData?.addresses?.length > 0){
      const mainAddress = rowData.addresses[0].addressLine.concat(' ', rowData.addresses[0].addressLine2);
      return (
        <>
          <div>{mainAddress}</div>
        </>
      );
    }
  };

  const totalEmployessbody = (rowData) => {
    return (
      <>
        <div className="action-btn">
          <button
            className="customTable action-btn btn btn-primary btn-hover-color me-2 py-1"
            onClick={(e) => {
              navigate('/enterprise/bond-admin/enterprise-activity', {
                state: {
                  selectedRowData: rowData,
                },
              });
            }}
          >
            Details
          </button>
          <button
            className="customTable action-btn btn btn-primary btn-hover-color me-2 py-1"
            onClick={(e) => {
              setModalShow(true);
              setSelectedRow(rowData);
            }}
          >
            Edit
          </button>
          <button
            className="customTable action-btn btn btn-primary btn-hover-color py-1"
            onClick={(e) => {
              setShowSendInvitePopup(true);
              setSelectedEnterpriseName(rowData.name);
              SetselectedEnterpriseLogo(rowData.logo?.presignedURL);
              setSelectedEnterpriseID(rowData.id);
            }}
          >
            Send Invite
          </button>
        </div>
        <div className="columnData">
          {/* {rowData.enterpriseEmployeeStats.total} */}
        </div>
      </>
    );
  };

  const templateForPaginator = {
    layout:
      'RowsPerPageDropdown  FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport',
    CurrentPageReport: (options) => {
      return (
        <span className="displaying-page-number mr-5">
          {options.currentPage} of {options.totalPages}
        </span>
      );
    },
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: 40, value: 40 },
        { label: 50, value: 50 },
        // { label: 'All', value: options.totalRecords }
      ];
      return (
        <>
          <div
            className="d-none d-md-none  d-sm-none d-xs-none  d-lg-flex "
            style={{ position: 'absolute', left: '2px' }}
          >
            <span className="Per-page">Per page</span>
            <Dropdown
              value={options.value}
              options={dropdownOptions}
              onChange={options.onChange}
              placeholder={'10'}
            />
            <span className="displaying-page-number ms-2 me-5">
              Displaying{' '}
              {(options.props.page + 1) * options.value > options.totalRecords
                ? options.totalRecords
                : (options.props.page + 1) * options.value}{' '}
              of {options.props.totalRecords}
            </span>
          </div>
        </>
      );
    },
  };
  return (
    <>
      <div className="row pt-4 pb-4">
        <div className="col-md-8">
          <div className="totalEnterpriseBlock me-7">
            <div className="blockTitle fw-bolder">Enterprises</div>
            <div className="blockNumber">
              {getOverallEnterpriseClientStats ? getOverallEnterpriseClientStats.getOverallEnterpriseClientStats.total : 'NA'}
            </div>
          </div>

          <div className="totalEnterpriseBlock" style={{ margin: '0 auto' }}>
            <div className="blockTitle fw-bolder">Active Enterprises</div>
            <div className="blockNumber">
              {getOverallEnterpriseClientStats ? getOverallEnterpriseClientStats.getOverallEnterpriseClientStats.active : 'NA'}
            </div>
          </div>
        </div>

        <div className="col-md-4 text-center">
          <div className="btn-large-block theme btn-primary-lg">
            <button
              className=" btn text-white fw-bolder w-100 h-100 p-0"
              onClick={() => {
                setModalShow(true);
                setSelectedRow('');
              }}
            >
              Create Enterprise
            </button>
            <AddEnterprise
              show={modalShow}
              onHide={() => setModalShow(false)}
              selectedRow={selectedRow}
              // refetch={() => fetchEnterpriseList()}
              refetch={() =>
                (window.location.href = '/enterprise/bond-admin/dashboard')
              }
            />
          </div>
        </div>
      </div>

      <div className="row m-0 customTable border">
        <div className="col-md-12">
          <div className="row customTable mainheader">
            <div className="col-md-8 ps-2 pt-1">
              <div className="customTable title">
                <label>Enterprise List</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="search-field position-relative">
                <div className="customTable static-search-mg">
                  <img
                    src={allImages.search}
                    className="img-fluid"
                    style={{ height: '1.2rem' }}
                    alt="search_icon"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control customTable custom-input-field"
                  value={globalFilterValue}
                  onChange={(e) => {
                    setFilter((filters) => ({
                      ...filters,
                      global: {
                        ...filters['global'],
                        value: e?.target?.value.trim(),
                      },
                    }));
                    setGlobalFilterValue(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 p-0">
          <DataTable
            value={data ? data.getEnterpriseClients.data : ''}
            rows={10}
            className="customTable tableHeight"
            paginator="true"
            paginatorPosition="bottom"
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            rowHover="true"
            scrollable
            scrollHeight="flex"
            resizableColumns="true"
            paginatorTemplate={templateForPaginator}
            globalFilterFields={[
              'name',
              'address',
              'website',
              'totalEmployees',
              'status',
            ]}
            filters={filters}
            emptyMessage={
              loading && (
                <h5 className="text-center h-100  pt-4 fw-bolder w-100">
                  There is no data to display at the moment.
                </h5>
              )
            }
          >
            <Column
              field="name"
              header="Enterprise Name"
              className="ps-4"
              body={enterpriseNameBody}
              sortable
            />
            <Column
              field="address"
              header="Address"
              body={enterpriseAddressBody}
              sortable
            />
            <Column
              field="status"
              header="Status"
              style={{ maxWidth: '10%' }}
              sortable
            />
            <Column
              field="url"
              header="Website"
              body={websiteBody}
              style={{ maxWidth: '15%' }}
              sortable
            />
            <Column
              field="totalEmployees"
              header="Total Employees"
              body={totalEmployessbody}
              style={{ maxWidth: '25%' }}
              sortable
            />
          </DataTable>
        </div>
      </div>

      <SendInvitation
        show={showSendInvitePopup}
        onHide={() => setShowSendInvitePopup(false)}
        entityName={selectedEnterpriseName}
        entityLogo={selectedEnterpriseLogo}
        entityID={selectedEnterpriseID}
      />
    </>
  );
};
